import * as React from "react";
import { cva } from "class-variance-authority";

import { cn } from "../../utils/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 text-center whitespace-nowrap",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-blue-200 text-primary-foreground hover:bg-blue-200/80",
        /** Chips neutros: días, +N más, contadores, estados suaves */
        secondary:
          "border-transparent bg-slate-200 text-slate-700 hover:bg-slate-200/90",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        /** Tipo de turno — unificado en la app */
        appointmentPrivate:
          "border-transparent bg-green-500 text-white hover:bg-green-500/90 shadow-sm",
        appointmentInsurance:
          "border-transparent bg-blue-500 text-white hover:bg-blue-500/90 shadow-sm",
        sobreturno:
          "border border-orange-200 bg-orange-200 text-orange-900 hover:bg-orange-200/90 shadow-sm",
        scheduleHabitual:
          "border-transparent bg-slate-500 text-white hover:bg-slate-500/90 shadow-sm",
        scheduleOccasional:
          "border-transparent bg-amber-500 text-white hover:bg-amber-500/90 shadow-sm",
        scheduleBlocked:
          "border-transparent bg-red-500 text-white hover:bg-red-500/90 shadow-sm",
        /** Formato de consulta (presencial / virtual / ambas) */
        consultationInPerson:
          "border-teal-200 bg-teal-50 text-teal-800",
        consultationVirtual:
          "border-violet-200 bg-violet-50 text-violet-800",
        consultationBoth:
          "border-sky-200 bg-sky-50 text-sky-800",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

function Badge({ className, variant, ...props }) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
